import React, { useRef, useState } from "react";
import { FacebookShareButton, TwitterShareButton } from "react-share";
import {
  Button,
  ClickAwayListener,
  Grow,
  ListItemText,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from "@mui/material";
import { FacebookIcon, LinkIcon, ShareIcon, TwitterIcon } from "../../../icons";

const PostShare = props => {
  const { title, url } = props;
  const [actionMenu, setActionMenu] = useState(false);
  const anchorRef = useRef(null);

  const actionMenuToggle = () => {
    setActionMenu(prevOpen => !prevOpen);
  };
  const actionMenuClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setActionMenu(false);
  };
  const CopyText = () => {
    navigator.clipboard.writeText(url);
  };

  return (
    <React.Fragment>
      <div className="events-page-post-share events6ix-dropdown">
        <Button
          title="Share"
          variant="outlined"
          className="events6ix-btn events6ix-btn-light events6ix-btn-sm events6ix-dropdown-btn"
          type="button"
          ref={anchorRef}
          aria-expanded={actionMenu ? "true" : undefined}
          aria-haspopup="true"
          onClick={actionMenuToggle}
          endIcon={<ShareIcon />}
        >
          Share
        </Button>

        <Popper
          open={actionMenu}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="bottom-end"
          transition
          disablePortal
          className="events6ix-dropdown-menu"
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom-end" ? "right top" : "right bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={actionMenuClose}>
                  <MenuList
                    autoFocusItem={actionMenu}
                    id="company-profile-banner-action-menu"
                    aria-labelledby="company-profile-banner-action-button"
                    className="events6ix-dropdown-list"
                  >
                    <MenuItem
                      className="events6ix-dropdown-list-item"
                      onClick={e => {
                        CopyText();
                        actionMenuClose(e);
                      }}
                    >
                      <LinkIcon />
                      <ListItemText>Copy link</ListItemText>
                    </MenuItem>
                    <FacebookShareButton
                      url={url}
                      quote={title}
                      hashtag="#6ix"
                      className="events-page-post-share-list"
                      onClick={e => {
                        actionMenuClose(e);
                      }}
                    >
                      <MenuItem
                        className="events6ix-dropdown-list-item"
                        onClick={e => {
                          actionMenuClose(e);
                        }}
                      >
                        <FacebookIcon />
                        <ListItemText>Share on Facebook</ListItemText>
                      </MenuItem>
                    </FacebookShareButton>

                    <TwitterShareButton
                      url={url}
                      title={title}
                      hashtags={["6ix"]}
                      className="events-page-post-share-list"
                    >
                      <MenuItem
                        className="events6ix-dropdown-list-item"
                        onClick={e => {
                          actionMenuClose(e);
                        }}
                      >
                        <TwitterIcon />
                        <ListItemText>Share on Twitter/X</ListItemText>
                      </MenuItem>
                    </TwitterShareButton>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </React.Fragment>
  );
};

export default PostShare;
